import React, { Component } from "react";
import { connect } from "react-redux";
import Frame from "../Frame";
import { finishApplication } from "../../actions";
import PropTypes from "prop-types";
class Katapult2Contract extends Component {

  receiveMessage = (event) => {
    const { finishApplication } = this.props

    if (event.data.katapultSDK === 'payment-success') {
      finishApplication();
    }
    return;
  }

  render() {
    const { contractUrl, hidden } = this.props
    return (
      <Frame
        hidden={hidden}
        contractUrl={contractUrl}
        onReceiveMessage={this.receiveMessage}
      />
    )
  }
}

Katapult2Contract.propTypes = {
  contractUrl: PropTypes.string
};

Katapult2Contract.defaultProps = {
  contractUrl: ""
};

const mapDistpatchToProps = dispatch => {
  return {
    finishApplication: values => dispatch(finishApplication(values))
  };
};

Katapult2Contract = connect(null, mapDistpatchToProps)(Katapult2Contract);

export default Katapult2Contract;
